import React, {Component} from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
// import { isEqual } from 'lodash'
import EventEmitter from '../../utils/events'

// Actions
import { getShopOwners } from '../../actions/shopowners'

// Utils
import { translation } from '../../utils/helpers'

// import styles
import './shopowners.scss'

// import components
import Header from '../../shared/components/Header'
import LeftMenuContent from '../../shared/components/Menus/LeftMenu/Content'
import CreateUser from '../../shared/components/CreateUser'

// Elements
import Button from '../../shared/elements/button'
import SideMenu from '../../shared/elements/sideMenu'
import SideMenuItem from '../../shared/elements/sideMenuItem'
import SideMenuCustomItem from '../../shared/elements/sideMenuCustomItem'
import Check from '../../shared/elements/check'

// Views
import View from './View'

class ShopOwners extends Component {

  constructor (props) {
    super(props)
    this.state = {
      view: 'list',
      search: '',
      includeInactive: false,
      shopowners: [],
      activeItem: {},
      includeNonVerified: false
    }
    this.headerButtonsRight = this.headerButtonsRight.bind(this)
    this.renderView = this.renderView.bind(this)
    this.searchList = this.searchList.bind(this)
    this.filterList = this.filterList.bind(this)
    this.onSave = this.onSave.bind(this)
    this.createView = this.createView.bind(this)
    this.onSelectItem = this.onSelectItem.bind(this)
  }

  componentDidMount () {
    this.getShopOwners()
  }

  getShopOwners () {
    this.props.getShopOwners(this.props.auth.user.ChainId).then((res) => {
      this.setState({
        shopowners: res.data
      })
      if (res.data.length === 0) {
        this.changeView('create')
      }
    }, () => {
      console.log('err')
    })
  }

  changeView (view) {
    let activeItem = this.state.activeItem
    if (view === 'create') {
      activeItem = {}
    }
    this.setState({
      view: view,
      activeItem: activeItem
    })
  }

  headerButtonsRight () {
    if (this.state.view === 'create') return null
    return (
      <div>
        <Button spacing={0} size='m' ariaText={translation('2054')} labelText={translation(1797)} onClick={this.changeView.bind(this, 'create')} />
      </div>
    )
  }

  searchList (e) {
    if (e.target.name === 'SearchText') {
      this.setState({
        search: e.target.value
      })
    }
    if (e.target.name === 'Inactive') {
      this.setState({
        includeInactive: e.target.checked
      })
    }
  }

  filterList (key) {
    // if (key.Name !== null) {
    if (key.Name.toLowerCase().indexOf(this.state.search.toLowerCase()) > -1 && (!this.state.includeInactive ? key.Active : true)) {
      return true
    }
    return false
    // }
    // return false
  }

  onSave (data, type) {
    let shopowners = [...this.state.shopowners]
    let activeItem
    if (type === 'create') {
      shopowners.push({
        UserId: data.UserId,
        Name: data.Name,
        Active: data.Active,
        Email: data.Email,
        Confirmed: false
      })
      type = 'item'
      activeItem = {
        UserId: data.UserId,
        Confirmed: false
      }
    } else {
      shopowners.map((val, key) => {
        if (val.UserId === data.UserId) {
          val.Name = data.Name
          val.Active = data.Active
          val.Email = data.Email
          val.Confirmed = data.Confirmed
        }
      })
      type = 'item'
      if (data.Confirmed) {
        activeItem = {
          UserId: data.UserId,
          Confirmed: true
        }
      } else {
        activeItem = {
          UserId: data.UserId,
          Name: data.Name,
          Email: data.Email,
          Confirmed: data.Confirmed
        }
      }
    }
    this.setState({
      shopowners: shopowners,
      view: type,
      activeItem: activeItem
    })
    // Toastr
    // window.toastr.success(translation('13464'), translation('13424'))
  }

  createView () {
    // If view is create
    if (this.state.view === 'create') {
      const onAdd = () => {
        this.refs.create.getWrappedInstance().createUser()
      }

      return [
        <SideMenuCustomItem key='0' isFixed>
          <Button onClick={onAdd} labelText={translation('1208')} />
        </SideMenuCustomItem>,
        <SideMenuCustomItem key='1' isFixed>
          <Button style='secondary' onClick={this.changeView.bind(this, 'list')} labelText={translation('570')} />
        </SideMenuCustomItem>
      ]
    }

    return [
      <div key='confirmedfilter' className='filter'>
        <SideMenuCustomItem isFixed>
          <Check
            name='NonVerified'
            checked={this.state.includeNonVerified}
            onChange={() => { this.setState({includeNonVerified: !this.state.includeNonVerified}) }}
            labelText={translation('16320')}
            spacing={0}
          />
        </SideMenuCustomItem>
      </div>,
      ...this.state.shopowners.map(so => {
        return (
          <SideMenuItem
            label={so.Name}
            onClick={() => this.onSelectItem(so)}
            selected={so.UserId === this.state.activeItem.UserId}
            inactive={!so.Active}
            confirmed={so.Confirmed}
            key={so.UserId}
          />
        )
      })
    ]
  }

  onSelectItem (item) {
    this.setState({
      view: 'item',
      activeItem: item
    })
    EventEmitter.emit('sidebar_trigger', false)
  }

  renderView () {
    switch (this.state.view) {
      case 'list':
        return <div />
      case 'create':
        return <CreateUser isShopOwner ref='create' title={translation('2054')} user={undefined} onSuccess={res => this.onSave(res, 'create')} />
      case 'item':
        if (this.state.activeItem.Confirmed !== true) return <CreateUser isShopOwner user={this.state.activeItem} title={translation('2054')} onSuccess={res => this.onSave(res, 'item')} />
        return <View router={this.props.router} ref='view' item={this.state.activeItem} onSave={this.onSave} />
    }
  }

  render () {
    const customFilter = (item, showInactive) => {
      // Include any items not confirmed if using this filter
      if (this.state.includeNonVerified && !item.confirmed) {
        return true
      }
      if (showInactive) {
        // Exclude unconfirmed
        return item.confirmed
      }
      return !item.inactive
    }

    return (
      <div className='shop-owners__screen'>
        <Header router={this.props.router} renderRight={() => this.headerButtonsRight()} />

        <SideMenu showFilter={this.state.view !== 'create'} hideInactiveCheck={this.state.view === 'create'} customFilter={customFilter}>
          {this.createView()}
        </SideMenu>

        <LeftMenuContent className='customers__screen--inner'>
          {this.renderView()}
        </LeftMenuContent>
      </div>
    )
  }

}

ShopOwners.propTypes = {
  auth: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, { getShopOwners })(ShopOwners)



// WEBPACK FOOTER //
// ./src/app/pages/ShopOwners/index.js